module.exports = __webpack_public_path__ + "static/media/air.ab04376f.png";